<script>
    import { querystring } from "svelte-spa-router";

    import { goBack } from "../../Utils/utilFunctions.svelte";

    import Button from "../../Components/Common/Button.svelte";

    import { apiMethods } from "../../Services/index.svelte";

    let isValidatingEmail = true;

    $: if ($querystring) validateEmailByQuery();
    else goBack();

    const validateEmailByQuery = () => {
        const queryArr = $querystring.split("&");
        if (queryArr.length == 2) {
            let code, email;
            if (
                queryArr[0].substr(0, 2) == "e=" &&
                queryArr[1].substr(0, 2) == "c="
            ) {
                code = queryArr[1].slice(2);
                email = queryArr[0].slice(2);
            } else if (
                queryArr[0].substr(0, 2) == "c=" &&
                queryArr[1].substr(0, 2) == "e="
            ) {
                code = queryArr[0].slice(2);
                email = queryArr[1].slice(2);
            } else goBack();

            if (code && email) {
                apiMethods.postMethod
                    .validateEmail({ code, email })
                    .then(() => (isValidatingEmail = false))
                    .catch((err) => (isValidatingEmail = false));
            }
        } else goBack();
    };

    const handleClickFunc = () => {
        if (window.history.length > 1) goBack();
        else window.close();
    };
</script>

<div class="flex-1 flex flex-col items-center w-full h-full p-6 showBG">
    <div class="flex items-center px-4 py-2">
        <img src="/favicon.png" alt="" class="w-[48px] h-[48px]" />
        <p class="text-primary text-2xl font-bold title-font pl-4">Anaemate</p>
    </div>

    <div class="flex flex-1 items-center justify-evenly w-full">
        <div class="artboard w-auto h-auto p-6 shadow-lg">
            <div class="flex flex-col items-center gap-y-4">
                <p class="text-xl text-bold">
                    Thank you for validating your email.
                </p>

                {#if window.history.length == 1}
                    <p class="text-lg">
                        Please go back to the onboarding screen to continue
                        signing up for Anaemate.
                    </p>
                {/if}

                <Button
                    clickFunc={handleClickFunc}
                    isDisabled={isValidatingEmail}
                    manualClass={isValidatingEmail ? "loading" : ""}
                >
                    {isValidatingEmail
                        ? "Validating..."
                        : window.history.length > 1
                          ? "Back"
                          : "Close"}
                </Button>
            </div>
        </div>
    </div>
</div>

<style>
    .artboard {
        background-color: #f7f7f7;
        border: 1px solid rgba(65, 91, 63, 0.25);
        box-shadow: 10px 10px 30px rgba(0, 0, 0, 0.1);
        border-radius: 15px;
    }

    .showBG {
        height: 100vh;
        background-image: url("/imgs/bg_signIn.png");
        background-repeat: no-repeat;
        background-attachment: fixed;
        background-position: bottom;
        background-size: contain;
    }
</style>
